import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { IError } from '@unfoldrtech/portal-mic'
import { AxiosError, AxiosResponse } from 'axios'
import { ICategoryAttribution } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId } from '../utils/helpers/generateCorrelationId'
import { coreAPIV3 } from '../services/coreAPIV3'

type TPutPutCategoryAttributionBatchMutationResult = UseMutationResult<
  AxiosResponse<void>,
  AxiosError<IError>,
  { payload: Array<ICategoryAttribution> }
>

export default function usePutCategoryAttributionBatch(params: {
  retailerId: number
}) {
  return useMutation(
    [`usePutCategoryAttributionBatch_${params.retailerId}`],
    ({ payload }) => {
      return coreAPIV3
        .retailerInventory()
        .putCategoryAttributionBatch(
          params.retailerId,
          generateCorrelationId(),
          payload
        )
    }
  ) as TPutPutCategoryAttributionBatchMutationResult
}
